<script setup>
import { ref } from "vue";
import flatPickr from "vue-flatpickr-component";
import { GRANULARITY_OPTIONS, TIMEZONE_OPTIONS, dateRangeConfig } from "../analysisOptions";
import { toDateInputValue } from "../analysisFormat";

const dateFrom = defineModel("dateFrom", { type: String, required: true });
const dateTo = defineModel("dateTo", { type: String, required: true });
const granularity = defineModel("granularity", { type: String, required: true });
const timezone = defineModel("timezone", { type: String, required: true });

const rangeValue = ref([dateFrom.value, dateTo.value]);

const onRangeChange = (selectedDates) => {
  if (!Array.isArray(selectedDates) || selectedDates.length === 0) return;
  dateFrom.value = toDateInputValue(selectedDates[0]);
  dateTo.value = toDateInputValue(selectedDates[selectedDates.length > 1 ? 1 : 0]);
};
</script>

<template>
  <div class="filter-block">
    <label class="form-label text-sm fw-semibold mb-1">Date range</label>
    <flat-pickr class="form-control" v-model="rangeValue" :config="dateRangeConfig" @on-change="onRangeChange" />
  </div>
  <div class="filter-block filter-block-sm">
    <label class="form-label text-sm fw-semibold mb-1">Timezone</label>
    <select class="form-select" v-model="timezone">
      <option v-for="tz in TIMEZONE_OPTIONS" :key="tz" :value="tz">{{ tz }}</option>
    </select>
  </div>
  <div class="filter-block filter-block-sm">
    <label class="form-label text-sm fw-semibold mb-1">Granularity</label>
    <select class="form-select" v-model="granularity">
      <option v-for="g in GRANULARITY_OPTIONS" :key="g" :value="g">{{ g }}</option>
    </select>
  </div>
</template>
